const PERIOD_CLOSED = 'periodClosed'
const PERIOD_OPENED = 'periodOpened'

export {
    PERIOD_CLOSED,
    PERIOD_OPENED
}